import { useMutation } from '@tanstack/react-query'
import { removeSubAdminParticipantFromGroup } from '..'

type RemoveSubAdminParticipantVariables = {
  groupId: string
  userId: string
}

const useRemoveSubAdminParticipant = () =>
  useMutation({
    mutationFn: ({ groupId, userId }: RemoveSubAdminParticipantVariables) =>
      removeSubAdminParticipantFromGroup(groupId, userId),
  })

export default useRemoveSubAdminParticipant
